export default __webpack_public_path__ + "static/media/html.e7638e36.svg";